import type { CloudEnvironment } from '../types/CloudEnvironment';
import type {
    CloudEnvironmentInfo,
    InputUrlType,
    NewAccountCloudEnvironmentInfo,
} from '../types/CloudEnvironmentInfo';
import { ensureOriginInRequest, ensureOriginInString } from 'owa-url/lib/ensureOrigin';
import { getOrigin } from 'owa-url/lib/getOrigin';
import { isSovereignEnvironment } from './isSovereignEnvironment';

export class CloudEnvironmentInfoImpl implements CloudEnvironmentInfo {
    protected environment: CloudEnvironment;

    constructor(environment: CloudEnvironment) {
        this.environment = environment;
    }

    buildOutlookUrl<T extends string | Request>(originalUrl: T): InputUrlType<T> {
        if (typeof originalUrl === 'string') {
            return ensureOriginInString(
                originalUrl,
                this.environment.outlookWebOrigin
            ) as InputUrlType<T>;
        }

        return ensureOriginInRequest(
            originalUrl,
            this.environment.outlookWebOrigin
        ) as InputUrlType<T>;
    }

    msaAuthenticationEndpoint(): string | undefined {
        return this.environment.msaAuthenticationEndpoint;
    }

    orgAuthenticationEndpoint(): string {
        return this.environment.orgAuthenticationEndpoint;
    }

    telemetrySafeDiagnosticData(): string {
        return JSON.stringify({
            appOrigin: getOrigin(),
            envKey: this.environment.environmentKey,
            msaAuthEndpoint: this.environment.msaAuthenticationEndpoint,
            orgAuthEndpoint: this.environment.orgAuthenticationEndpoint,
            outlookWebOrigin: this.environment.outlookWebOrigin,
            tenantId: this.environment.tenantId,
            usesGlobalDirectory: this.environment.usesGlobalDirectory,
        });
    }

    tenantId(): string | undefined {
        return this.environment.tenantId;
    }
}

export class NewAccountCloudEnvironmentInfoImpl
    extends CloudEnvironmentInfoImpl
    implements NewAccountCloudEnvironmentInfo
{
    isSameAsApplicationCloud(): boolean {
        const applicationOrigin = getOrigin();
        return applicationOrigin === this.buildOutlookUrl(applicationOrigin);
    }

    isSovereign(): boolean {
        return isSovereignEnvironment(this.environment);
    }
}
